import { Action } from '@ngrx/store';
import {Filters} from '../../models/filters';
import * as actions from '../actions';

export interface FiltersState {
  moduleRegion?: number;
  nodeRegion?: number;
}

export const initialState: Filters = {
  moduleRegion: null,
  nodeRegion: null
};

export function reducer(state = initialState, action: actions.FilterActions): FiltersState {
  switch (action.type) {
    case actions.FilterActionTypes.GetModuleFilters:
      return {...state, moduleRegion: action.payload.moduleRegion};
    case actions.FilterActionTypes.GetNodeFilters:
      return {...state, nodeRegion: action.payload.nodeRegion};
    default:
      return state;
  }
}

export const getFilters = (state: Filters) => state;
